<script>
    import { onMount } from 'svelte';
    import { store } from '../Store.svelte';

    const updateFavicon = () => {
        const favicon =
            document.getElementById('dynamic-favicon') ||
            document.createElement('link');

        favicon.rel = 'icon';
        favicon.type = 'image/png';
        favicon.href = $store.requestedServices.isSky
            ? '/favicon-sky.ico'
            : '/favicon-izzi.ico';

        if (!document.getElementById('dynamic-favicon')) {
            favicon.id = 'dynamic-favicon';
            document.head.appendChild(favicon);
        }
    };

    const updateTitle = () => {
        document.title = $store.requestedServices.isSky
            ? 'Paquetes de Televisión con Sky ¡Aprovecha!'
            : 'Paquetes de Internet y Llamadas ilimitadas con izzi ¡Aprovecha!';
    };

    onMount(() => {
        updateFavicon();
        updateTitle();

        window.addEventListener('popstate', () => {
            updateFavicon();
            updateTitle();
        });
    });
</script>
